var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 2.66683C5.05452 2.66683 2.66671 5.05464 2.66671 8.00016C2.66671 10.9457 5.05452 13.3335 8.00003 13.3335C10.9455 13.3335 13.3334 10.9457 13.3334 8.00016C13.3334 5.05464 10.9455 2.66683 8.00003 2.66683ZM1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00003 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00003 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016Z",
    fill: "#485D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 4.6665C7.63185 4.6665 7.33337 4.96498 7.33337 5.33317C7.33337 5.70136 7.63185 5.99984 8.00004 5.99984C8.36823 5.99984 8.66671 5.70136 8.66671 5.33317C8.66671 4.96498 8.36823 4.6665 8.00004 4.6665Z",
    fill: "#485D7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 7.99984C8.66671 7.63165 8.36823 7.33317 8.00004 7.33317C7.63185 7.33317 7.33337 7.63165 7.33337 7.99984V10.6665C7.33337 11.0347 7.63185 11.3332 8.00004 11.3332C8.36823 11.3332 8.66671 11.0347 8.66671 10.6665V7.99984Z",
    fill: "#485D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLine);
export default __webpack_public_path__ + "static/media/info-line.b1d323b4.svg";
export { ForwardRef as ReactComponent };